import React from 'react';

import './style.scss';

const DuplicateCheckLoader: React.FC = () => (
  <div className="duplicate-check-loader" role="status" aria-live="polite" aria-label="Processing your submission">
    <div className="duplicate-check-loader__card">
      <p className="duplicate-check-loader__message">Processing your submission...</p>
      <div className="duplicate-check-loader__bar" aria-hidden="true">
        <div className="duplicate-check-loader__bar-fill" />
      </div>
    </div>
  </div>
);

export default DuplicateCheckLoader;
